import axios from "axios";
import { BASE_URL } from "./api";

export async function getClientTaskTypes(token) {
    // console.log('getcollectionTags')
    return axios({
        method: "get",
        url: `${BASE_URL}/client_task_types`,
        headers: {
            'Authorization': `Token ${token}`
        }
    })
    .then(response => response)
    .catch(error => console.error(error))
}